import React from 'react';

const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

/**
 * LandingDashboardCard replicates the dashboard summary card styling
 * from the Landing Page context so the component can evolve independently.
 */
const LandingDashboardCard = ({
  icon,
  title,
  count,
  subtitle,
  badgeCount,
  badgeLabel,
  isActive = false,
  onClick,
  onCountClick,
  countColor,
  iconColor = '#e0e7ff',
  iconTint = '#1f2937'
}) => {
  const cardStyle = {
    cursor: onClick ? 'pointer' : 'default',
    transition: 'all 0.2s ease',
    border: isActive ? '2px solid #42b0d5' : '1px solid #9ca3af',
    // boxShadow: isActive ? '0 4px 12px rgba(37, 145, 221, 0.35)' : 'none',
    height: '100%',
    padding: '20px',
    borderRadius: '16px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    fontFamily: maerskFontFamily
  };

  const iconContainerStyle = {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    backgroundColor: iconColor || '#dbeafe',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    backgroundColor: iconTint,
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '4px'
  };

  const headerTitleGroupStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  };

  const titleBlockStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  };

  const countStyle = {
    fontSize: '34px',
    fontWeight: 600,
    lineHeight: 1,
    color: countColor || '#111827',
    textAlign: 'left',
    cursor: onCountClick ? 'pointer' : (onClick ? 'pointer' : 'default'),
    transition: 'opacity 0.2s ease'
  };

  const handleCountClick = (e) => {
    if (onCountClick) {
      e.stopPropagation();
      onCountClick();
    }
  };

  const titleStyle = {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: '#4b5563',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontFamily: maerskFontFamily,
    textAlign: 'left'
  };

  const bodySubtitleStyle = {
    fontSize: '1rem',
    color: '#4b5563',
    fontWeight: 500,
    fontFamily: maerskFontFamily,
    textAlign: 'left'
  };

  const badgeContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '12px'
  };

  const badgeStyle = (customColor) => ({
    backgroundColor: customColor?.bg || '#fee2e2',
    color: customColor?.text || '#991b1b',
    padding: '6px 12px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  });

  const badgeCountStyle = {
    fontSize: '16px',
    fontWeight: '700',
    color: '#111827'
  };

  return (
    <div style={cardStyle} onClick={onClick}>
      <div style={headerStyle}>
        <div style={headerTitleGroupStyle}>
          <div style={iconContainerStyle}>
            {icon}
          </div>
          <div style={titleBlockStyle}>
            <div style={titleStyle}>{title}</div>
          </div>
        </div>
        {(badgeCount !== undefined && badgeCount > 0 && badgeLabel) && (
          <div style={badgeStyle(badgeLabel === 'Lists' ? { bg: '#fef3c7', text: '#92400e' } : undefined)}>
            <span style={badgeCountStyle}>{badgeCount}</span>
            <span>{badgeLabel}</span>
          </div>
        )}
      </div>
      <div 
        style={{
          ...countStyle,
          ...(onCountClick && { ':hover': { opacity: 0.8 } })
        }} 
        onClick={handleCountClick}
        onMouseEnter={(e) => {
          if (onCountClick) e.currentTarget.style.opacity = '0.8';
        }}
        onMouseLeave={(e) => {
          if (onCountClick) e.currentTarget.style.opacity = '1';
        }}
      >
        {count}
      </div>
      <div style={bodySubtitleStyle}>{subtitle}</div>
      {(badgeCount !== undefined && badgeCount > 0 && !badgeLabel) && (
        <div style={badgeContainerStyle}>
          <span style={badgeStyle()}>
            <span style={badgeCountStyle}>{badgeCount}</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default LandingDashboardCard;
